module.exports = __webpack_public_path__ + "img/icon_upload.e5430fca.png";